import { render, staticRenderFns } from "./BulkCreate.vue?vue&type=template&id=5b632144&scoped=true&"
import script from "./BulkCreate.vue?vue&type=script&lang=js&"
export * from "./BulkCreate.vue?vue&type=script&lang=js&"
import style0 from "./BulkCreate.vue?vue&type=style&index=0&id=5b632144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b632144",
  null
  
)

export default component.exports